<div class="border-1 bg-white p-3 border-round-lg border-gray-400" id="otherParkingLocationParent">
  <div class="mb-3" *ngIf="!isVME">Where will you park the vehicle during carryover?</div>
  <div class="mb-3" *ngIf="isVME">Where will the supplier park the vehicle during carryover?</div>
  <div class="flex flex-column pl-2">
    <p-radioButton
      (onClick)="onHomeChosen()"
      class="mb-2"
      [(ngModel)]="parkingOption"
      name="parking"
      value="home"
      [label]="isVME ? 'Supplier Home' : 'Home'"
    ></p-radioButton>
    <p-radioButton
      (onClick)="onOtherChosen()"
      [(ngModel)]="parkingOption"
      name="parking"
      value="other"
      label="Other"
    ></p-radioButton>
  </div>
  <div class="flex ml-2 mt-3 flex-grow-1 style2023">
    <div class="input-group w-full" [class.hidden]="parkingOption != 'other' || !showOtherInput">
      <span class="input-group-item w-full">
        <input
          pInputText
          [(ngModel)]="parkingLocation"
          placeholder="Search Address"
          id="otherParkingLocation"
        />
      </span>
    </div>

    <div [class.hidden]="showOtherInput" class="w-full">{{ selectedLocation?.addressLine }}</div>
    <div
      class="cursor-pointer hover:text-blue-600 text-lg"
      [class.hidden]="parkingOption == 'home' || showOtherInput || !selectedLocation"
      (click)="onEditOtherLocation()"
    >
      <i class="fa fa-pencil"></i>
    </div>
  </div>

  <div class="flex ml-2 mt-3 gap-2 text-gray-700" *ngIf="isValidating">
    <i class="fa fa-spinner fa-spin mt-1"></i>
    <div>Checking this address is suitable for carryovers...</div>
  </div>

  <div class="flex ml-2 mt-3 gap-2" *ngIf="validationFailed && !isValidating">
    <i class="fa fa-exclamation-circle text-red-600 mt-1"></i>
    <div>
      <div class="text-red-600 font-bold">Could not check this address</div>
      <div class="text-gray-700">
        Something went wrong checking whether this address is suitable for carryovers.
      </div>
      <button
        type="button"
        pButton
        label="Try Again"
        id="retryCarryoverValidation"
        class="ui-button-secondary mt-3"
        (click)="onRetryValidation()"
      ></button>
    </div>
  </div>

  <div class="flex ml-2 mt-3 gap-2" *ngIf="validationResult && !isValidating">
    <ng-container *ngIf="validationResult.outcome == ValidationOutcome.Suitable">
      <ng-container *ngIf="!validationResult.requiresReview">
        <i class="fa fa-check-circle text-green-600 mt-1"></i>
        <div>
          <div class="text-green-600 font-bold">Address suitable</div>
          <div class="text-gray-700">This carryover will be auto-approved.</div>
        </div>
      </ng-container>

      <ng-container *ngIf="validationResult.requiresReview">
        <i class="fa fa-info-circle text-orange-500 mt-1"></i>
        <div>
          <div class="text-orange-500 font-bold">Excess mileage suitable</div>
          <div class="text-gray-700">
            Operations still need to review this carryover. You can continue.
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="validationResult.outcome == ValidationOutcome.AddressNotFound">
      <i class="fa fa-exclamation-circle text-red-600 mt-1"></i>
      <div>
        <div class="text-red-600 font-bold">Address not found</div>
        <div class="text-gray-700">{{ validationResult.message }}</div>
      </div>
    </ng-container>

    <ng-container *ngIf="validationResult.outcome == ValidationOutcome.CheckUnavailable">
      <i class="fa fa-info-circle text-orange-500 mt-1"></i>
      <div>
        <div class="text-orange-500 font-bold">Carryover mileage not checked</div>
        <div class="text-gray-700">
          {{ validationResult.message }} Operations will review this carryover. You can continue.
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="validationResult.outcome == ValidationOutcome.MileageUnsuitable">
      <i class="fa fa-exclamation-triangle text-red-600 mt-1"></i>
      <div>
        <div class="text-red-600 font-bold">Address not suitable</div>
        <div class="text-gray-700">
          Carrying over at this address adds too much mileage. Please choose a different carryover
          address, or schedule this task without a carryover. If you cannot find a suitable
          schedule, you may request to handback this job.
        </div>
        <button
          type="button"
          pButton
          *ngIf="!isVME"
          [label]="handbackButtonLabel"
          id="requestCarryoverHandback"
          class="ui-button-secondary mt-3"
          (click)="onRequestHandback()"
        ></button>
      </div>
    </ng-container>
  </div>
</div>

<p-dialog
  [header]="canHandBackImmediately ? 'Hand Back Job' : 'Request a Hand Back'"
  [modal]="true"
  [(visible)]="showHandbackDialog"
  styleClass="line-height-3"
  [style]="{ width: '480px' }"
  [closable]="!isHandingBack"
>
  <div class="py-2">
    <ng-container *ngIf="canHandBackImmediately">
      <p class="mt-0 mb-3">Are you sure you want to hand back this job?</p>
      <p class="m-0 text-gray-700">
        The job will be removed from your jobs and returned to Engineius.
      </p>
    </ng-container>

    <ng-container *ngIf="!canHandBackImmediately">
      <p class="mt-0 mb-3">
        This job can no longer be handed back automatically, as the hand back period has passed.
      </p>
      <p class="mt-0 mb-3 text-gray-700">
        To request a hand back, please call the Engineius operations team.
      </p>
      <a
        *ngIf="engineiusPhone"
        href="tel:{{ engineiusPhone }}"
        class="flex align-items-center gap-2 text-xl font-bold"
      >
        <i class="fa fa-phone"></i>
        <span>{{ engineiusPhone }}</span>
      </a>
      <p class="m-0 text-gray-700" *ngIf="!engineiusPhone">
        Their number is shown at the top of the menu.
      </p>
    </ng-container>
  </div>

  <p-footer>
    <button
      type="button"
      pButton
      [label]="canHandBackImmediately ? 'Cancel' : 'Close'"
      class="ui-button-secondary"
      [disabled]="isHandingBack"
      (click)="showHandbackDialog = false"
    ></button>
    <button
      type="button"
      pButton
      *ngIf="canHandBackImmediately"
      label="Hand Back"
      class="ui-button-danger"
      [disabled]="isHandingBack"
      (click)="onConfirmHandback()"
    ></button>
  </p-footer>
</p-dialog>
